import React, { createContext, useContext, useState } from "react";

const UnsavedLabsContext = createContext(null);

export function UnsavedLabsProvider({ children }) {
  const [hasUnsavedInhouseLabs, setHasUnsavedInhouseLabs] = useState(false);
  const [hasUnsavedExternalLabs, setHasUnsavedExternalLabs] = useState(false);
  return (
    <UnsavedLabsContext.Provider
      value={{
        hasUnsavedInhouseLabs,
        setHasUnsavedInhouseLabs,
        hasUnsavedExternalLabs,
        setHasUnsavedExternalLabs,
      }}
    >
      {children}
    </UnsavedLabsContext.Provider>
  );
}

export function useUnsavedLabs() {
  const context = useContext(UnsavedLabsContext);
  return context;
}
